import { Colors } from '~/themes/colors';

export enum JobPostingStatus {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft',
  Suspended = 'suspended',
}

const colors = {
  [JobPostingStatus.Active]: Colors.secondary_600,
  [JobPostingStatus.Closed]: Colors.neutral_400,
  [JobPostingStatus.Draft]: Colors.secondary_200,
  [JobPostingStatus.Suspended]: Colors.warning_500,
};

const translations = {
  [JobPostingStatus.Active]: 'Active',
  [JobPostingStatus.Closed]: 'Closed',
  [JobPostingStatus.Draft]: 'Draft',
  [JobPostingStatus.Suspended]: 'Suspended',
};

export const JobPostingStatusMapper = {
  getColor: (it: JobPostingStatus) => colors[it],
  toHumanReadable: (it: JobPostingStatus) => translations[it],
  safeCast: (it?: string): JobPostingStatus | undefined => {
    if (!it) return undefined;
    return Object.values(JobPostingStatus).find((status) => status === it?.toLowerCase());
  },
};
